// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__121h0","inputDescription":"styles_inputDescription__1QKVF"};